import React from 'react';
import PropTypes from 'prop-types';

import SrSimpleMessageModal, {
  SR_SIMPLE_MESSAGE_MODAL_THEME_SLIDE_UP,
} from 'client/components/SrSimpleMessageModal/SrSimpleMessageModal';
import {
  SR_BUTTON_THEME_ADOBE_BLUE,
  SR_BUTTON_THEME_ADOBE_GREEN,
} from 'client/components/SrButton/SrButton';

const UPPartnerPayoutFlowTransferInitiatedStep = ({ onClose }) => {
  const onGetReferral = () => {
    onClose();
    global.open('https://sunroomrentals.com/learn-more-utility-referrals');
  };

  return (
    <SrSimpleMessageModal
      iconUrl="/images/checkmark-circle-large-green.svg"
      maxIconHeight="50px"
      maxIconWidth="50px"
      contentContainerClassName="utilityProviderContact"
      headline="Transfer initiated!"
      underline
      maxWidth={400}
      message={
        'It takes 5-7 business days to receive the money in your bank. ' +
        'It will be labeled as “Utility Profit.”'
      }
      theme={SR_SIMPLE_MESSAGE_MODAL_THEME_SLIDE_UP}
      srMultiButtons={[
        {
          buttonText: 'Ok thanks',
          onButtonClick: onClose,
          buttonTheme: SR_BUTTON_THEME_ADOBE_GREEN,
        },
        {
          buttonText: 'Get $1,000 with referral →',
          onButtonClick: onGetReferral,
          buttonTheme: SR_BUTTON_THEME_ADOBE_BLUE,
        },
      ]}
    />
  );
};

UPPartnerPayoutFlowTransferInitiatedStep.displayName = 'UPPartnerPayoutFlowTransferInitiatedStep';

UPPartnerPayoutFlowTransferInitiatedStep.propTypes = {
  onClose: PropTypes.func.isRequired,
};

export default UPPartnerPayoutFlowTransferInitiatedStep;
